<h2 mat-dialog-title>Error!</h2>
<mat-dialog-content class="mat-typography">
  <p>error message goes here...</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>CONFRIM</button>
  <!-- <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Continue</button> -->
</mat-dialog-actions>
